module.exports = __webpack_public_path__ + "static/HyperCasual-4c24087cddcc83ce87c95c228d1e7747.png";